import controller from './icon-help.controller';
import template from './icon-help.html';

export default {
	template,
	bindings: {
		class: '@?',
		id:    '@',
	},
	controller,
};
